import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const LoginPage = lazy(() => import('../pages/Public/Login/LoginPage').then(m => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('../pages/Public/Register/RegisterPage').then(m => ({ default: m.RegisterPage })));
const SelectWorkspacePage = lazy(() => import('../pages/Public/SelectWorkspacePage').then(m => ({ default: m.SelectWorkspacePage })));
const PasswordResetRequestPage = lazy(() => import('../pages/Public/PasswordReset/PasswordResetRequestPage').then(m => ({ default: m.PasswordResetRequestPage })));
const PasswordResetConfirmPage = lazy(() => import('../pages/Public/PasswordReset/PasswordResetConfirmPage').then(m => ({ default: m.PasswordResetConfirmPage })));
const SsoFreshdesk = lazy(() => import('../pages/Public/SsoFreshdesk/SsoFreshdesk').then(m => ({ default: m.SsoFreshdesk })));

const PublicLayout = () => {
  usePageTitle();
  return <Outlet />;
};

export const publicRoutes = [
  {
    element: <PublicLayout />,
    children: [
      { path: '/auth/login',       element: <LoginPage />,                   handle: { title: 'Iniciar Sesión' } },
      { path: '/auth/register',    element: <RegisterPage />,                handle: { title: 'Registrarse' } },
      { path: '/auth/reset',         element: <PasswordResetRequestPage />,    handle: { title: 'Recuperar Contraseña' } },
      { path: '/auth/reset-confirm', element: <PasswordResetConfirmPage />,   handle: { title: 'Nueva Contraseña' } },
      { path: '/select-workspace', element: <SelectWorkspacePage />,         handle: { title: 'Seleccionar Empresa' } },
      { path: '/login',            element: <LoginPage />,                   handle: { title: 'Iniciar Sesión' } },
      { path: '/register',         element: <RegisterPage />,                handle: { title: 'Registrarse' } },
      { path: '/sso/freshdesk',    element: <SsoFreshdesk />,                handle: { title: 'Acceso Freshdesk' } },
    ],
  },
];
